var map = {
	"./120x600.png": 58,
	"./160x600.png": 59,
	"./240x400.png": 60,
	"./300x250.png": 61,
	"./300x300.png": 62,
	"./300x600.png": 63,
	"./320x100.png": 64,
	"./320x50.png": 65,
	"./336x280.png": 66,
	"./580x400.png": 67,
	"./600x150.png": 68,
	"./600x300.png": 69,
	"./728x150.png": 70,
	"./728x300.png": 71,
	"./728x90.png": 72,
	"./970x250.png": 73,
	"./970x90.png": 74
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 189;